import React, { useEffect, useMemo } from 'react';
import { useParams, Link } from 'react-router-dom';
import CartPanel from '../sections/CartPanel';
import Navbar from '../sections/Navbar';
import Footer from '../sections/Footer';
import ProductHeader from '../sections/ProductHeader';
import ProductMoreDetails from '../sections/ProductMoreDetails';
import ProductCarousel from '../sections/ProductCarousel';
import CtaSection from '../sections/CtaSection';

// --- 1. IMPORT the static JSON data directly ---
import productData from '../data/products.json';

const ProductDetailScreen = () => {
  const { productId } = useParams();

  // --- 2. FIND the product and similar products from the imported data ---
  const { product, similarProducts } = useMemo(() => {
    // The `productId` from the URL is a string, but the ID in your JSON is a number.
    // We must convert it to a number for the comparison to work.
    const currentProductId = parseInt(productId, 10);
    
    const currentProduct = productData.products.find(p => p.id === currentProductId);

    let similar = [];
    if (currentProduct) {
      similar = productData.products.filter(
        p => p.category === currentProduct.category && p.id !== currentProduct.id
      );
    }
    
    return { product: currentProduct, similarProducts: similar };
  }, [productId]); // This recalculates only when the productId in the URL changes

  // --- REMOVED: All useState and useEffect hooks for data fetching ---

  // Scroll to the top when the page loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [productId]);

  // --- 3. RENDER a "Not Found" message if the product doesn't exist ---
  if (!product) {
    return (
        <>
            <Navbar />
            <div className="not-found-container">
              <div className="not-found-content">
                <h2>Product not found</h2>
                <Link to="/store" className="back-to-menu-link">Back to Store</Link>
              </div>
            </div>
            <Footer />
        </>
    );
  }

  // --- 4. RENDER the main page content if the product is found ---
  return (
    <>
      <Navbar />
      <CartPanel />
      <main className="page-content">
        {/* Pass the found product to the header component */}
        <ProductHeader product={product} />
        
        {/* Pass the `moreDetails` array to its component */}
        <ProductMoreDetails details={product.moreDetails} />
        
        {similarProducts.length > 0 && (
          <ProductCarousel title="Similar Products" products={similarProducts} />
        )}
      </main>
      <CtaSection />
      <Footer />
    </>
  );
};

export default ProductDetailScreen;